import { Component, OnInit, Input } from '@angular/core';
import { LocalService } from '../../../service/local.service';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  styleUrls: ['./view-image.component.scss']
})
export class ViewImageComponent implements OnInit {
  id = ''; @Input() url = '';
  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    if (!this.url) {
      this.url = environment.url.image + this.id + ".jpg";
    }
  }

}
